import React, { ReactElement } from 'react';
import { PhoneIcon } from '../icons/icons';

const Phone: React.FC<{ className?: string }> = ({
  className,
}): ReactElement => (
  <a
    href="tel:+40727959955"
    className={`cursor-pointer flex items-center ${className}`}
  >
    <PhoneIcon />
    <span className="ml-1">0727959955</span>
  </a>
);

export default Phone;
